var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-ciec is-flex is-centered" },
    [
      _vm.hasCiec
        ? _c(
            "b-button",
            {
              staticClass: "ciec-sync-button",
              attrs: {
                size: "is-medium",
                type: "is-primary",
                "icon-left": "sync"
              },
              on: { click: _vm.forceSync }
            },
            [_vm._v("\n    Forzar sincronización\n  ")]
          )
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "add-ciec", mode: "out-in" } },
        [
          !_vm.loading
            ? _c("add-ciec-form", { on: { submit: _vm.saveCIEC } })
            : _c("add-ciec-loading")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }